import React from "react";
import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../../utils/axios"; // Assuming axiosInstance is configured with the base URL and headers
import AdminSidebar from "../../../components/AdminSidebar";
import { toast } from "react-toastify";
import excelIcon from "../../../assets/excel-icon.webp";
import Button from "../../../components/Button";

const TotalQuantityReport = () => {
  const exportMutation = useMutation({
    mutationFn: async () => {
      const response = await axiosInstance.get(
        `${window.REACT_APP_API_ENDPOINT}/export-excel/summary-report`,
        {
          responseType: "blob", // This tells Axios to expect a file
        }
      );
      return response;
    },
    onSuccess: (response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `total_quantity_report_${new Date().toISOString().split("T")[0]}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url); // Clean up

      toast.success("Report exported successfully!");
    },
    onError: (error) => {
      console.error("Export error:", error);
      toast.error("Failed to export report. Please try again.");
    },
  });

  const downloadExcelFile = () => {
    exportMutation.mutate();
  };

  const exportByModelMutation = useMutation({
    mutationFn: async () => {
      const response = await axiosInstance.get(
        `${window.REACT_APP_API_ENDPOINT}/export-excel/summary-report?export_by_model=true`,
        {
          responseType: "blob", // This tells Axios to expect a file
        }
      );
      return response;
    },
    onSuccess: (response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `total_quantity_report_by_model_${
          new Date().toISOString().split("T")[0]
        }.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url); // Clean up

      toast.success("Report exported successfully!");
    },
    onError: (error) => {
      console.error("Export error:", error);
      toast.error("Failed to export report. Please try again.");
    },
  });

  const handleExportByModel = () => {
    exportByModelMutation.mutate();
  };

  return (
    <AdminSidebar>
      <div className="space-y-6 px-4 sm:px-6 lg:px-8 ">
        <div className="sm:flex sm:items-center sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
              Total Quantity Report
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              View and analyze the total quantity of stock items
            </p>
          </div>
        </div>

        {/* Report content will go here */}
        <div className="bg-white shadow-lg rounded-lg p-8">
          <div className="space-y-6 ">
            <p className="text-lg font-semibold text-gray-700 max-w-2xl">
              This report provides a comprehensive overview of the total
              quantity of stock items available in the inventory. You can export
              this data for further analysis and record-keeping.
            </p>
            <div className="flex flex-col md:flex-row gap-4">
              <Button
                variant="outline-success"
                icon={excelIcon}
                size="lg"
                onClick={downloadExcelFile}
              >
                Export Total Quantity Data as Excel
              </Button>
              <Button
                variant="outline-warning"
                icon={excelIcon}
                size="lg"
                onClick={handleExportByModel}
              >
                Export Total Quantity Data By Model Order
              </Button>
            </div>
            <p className="text-sm text-gray-500">
              Note: The exported file will be in Excel format and will include
              all relevant data for the selected period.
            </p>
          </div>
        </div>
      </div>
    </AdminSidebar>
  );
};

export default TotalQuantityReport;
